//imports
import { all } from 'redux-saga/effects';

//Views
import manufacturersOverviewSagas from 'Modules/manufacturers/views/overview/redux/saga';
import refreshFirmwareSagas from 'Modules/manufacturers/.components/refreshFirmware/redux/saga';
import createEditPartNumberSagas from 'Modules/manufacturers/.components/partNumbersTab/.components/createEditPartNumber/redux/saga';
import deletePartNumberSagas from 'Modules/manufacturers/.components/partNumbersTab/.components/deletePartNumber/redux/saga';
import assignFirmwareSagas from 'Modules/manufacturers/.components/firmwareTab/.components/assignFirmware/redux/saga';
import refreshDevicesConfigSagas from 'Modules/manufacturers/.components/refreshDevicesConfig/redux/saga';
import createEditCannedCommandSagas from 'Modules/manufacturers/.components/cannedCommandsTab/.components/createEditCannedCommand/redux/saga';
import deleteCannedCommandsagas from 'Modules/manufacturers/.components/cannedCommandsTab/.components/deleteCannedCommand/redux/saga';
import createEditUnitTypeSagas from 'Modules/manufacturers/.components/unitTypesTab/.components/createEditUnitType/redux/saga';
import deleteUnitTypeSagas from 'Modules/manufacturers/.components/unitTypesTab/.components/deleteUnitType/redux/saga';
import showUnitTypeEventsSagas from 'Modules/manufacturers/.components/unitTypesTab/.components/showUnitTypeEvents/redux/saga';
import createEditManufacturerSagas from 'Modules/manufacturers/views/.components/createEditManufacturer/redux/saga';
import deleteManufacturerSagas from 'Modules/manufacturers/views/.components/deleteManufacturer/redux/saga';
import createEditDeviceModelSagas from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/redux/saga';
import editAlertTypeSupportedSagas from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/.components/editAlertTypeSupported/redux/saga';
import bulkAssignAlertTypesSagas  from 'Modules/manufacturers/.components/deviceModelsTab/.components/bulkAssignAlertTypes/redux/saga';
import syncCTCInformationSagas from 'Modules/manufacturers/views/.components/syncCTCInformation/redux/saga';
//merge sagas
export default function* rootSaga() {
    yield all([
        manufacturersOverviewSagas(),
        refreshFirmwareSagas(),
        createEditPartNumberSagas(),
        deletePartNumberSagas(),
        assignFirmwareSagas(),
        refreshDevicesConfigSagas(),
        createEditCannedCommandSagas(),
        deleteCannedCommandsagas(),
        createEditUnitTypeSagas(),
        deleteUnitTypeSagas(),
        showUnitTypeEventsSagas(),
        createEditManufacturerSagas(),
        deleteManufacturerSagas(),
        createEditDeviceModelSagas(),
        editAlertTypeSupportedSagas(),
        bulkAssignAlertTypesSagas(),
        syncCTCInformationSagas(),
    ]);
}